module.exports = __webpack_public_path__ + "img/TH-flag.3d072d29.svg";